import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import PropTypes from 'prop-types';

export const DeleteCardDialog = ({
    title,
    bodyText,
    onClose,
    arrayHelpers,
    indexToDelete = undefined,
    cardComponent,
}) => (
    <WarningDialog
        dialogTitle={`Delete ${title}`}
        width={700}
        isOpen={indexToDelete >= 0}
        primaryButtonLabel={`Yes, Delete ${title}`}
        primaryButtonIntent={Button.Intent.DANGER}
        onPrimaryButtonClick={() => {
            arrayHelpers.remove(indexToDelete);
            onClose();
        }}
        secondaryButtonLabel="No, Cancel"
        onSecondaryButtonClick={onClose}
        dialogContent={
            <>
                <div className="padding__bottom--medium">{bodyText}</div>
                {cardComponent}
            </>
        }
    />
);

DeleteCardDialog.propTypes = {
    title: PropTypes.string.isRequired,
    bodyText: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    arrayHelpers: PropTypes.shape({
        remove: PropTypes.func.isRequired,
    }).isRequired,
    indexToDelete: PropTypes.number,
    cardComponent: PropTypes.node.isRequired,
};
